import * as C from '../models/calendar/constants';

const InitialState = {
    data: {},
    timestamp: (new Date()).getTime()
};

export default (state = InitialState, action) => {
    if (action.type && C[action.type]) {
        return {
            state: action.type,
            data: action.data || {}
        };
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/calendar.reducer.js